import axios from "axios";

export default {
    async axiosGet(route, clientId) {
        if(process.env.VUE_APP_DEV === 'true') route = new URL(`http://${process.env.VUE_APP_SERVER}${route}`);
        return await axios.get(route, { headers: { token: await clientId() } })
            .then(res => {
                if (res.status == 200) {
                    return { data: res.data, status: true };
                }
                return [];
            })
            .catch((e) => { return {data: e, status: false} });
    },
    async axiosPost(route, requestContent, clientId) {
        if(process.env.VUE_APP_DEV === 'true') route = new URL(`http://${process.env.VUE_APP_SERVER}${route}`);
        return await axios.post(route, requestContent, { headers: { token: await clientId() } })
            .then((res) => {
                return { status: true, code: res.status, data: res.data }
            })
            .catch(() => { return {status: false, code: null} });
    }
}